<div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-dialog-centered custom-modal">
    <div class="modal-content">
      <div class="modal-body text-center">
        <div class="illustration-container">
          <div class="laptop-illustration">
            <!-- Laptop with map interface -->
            <img src="assets/images/Illustration.svg" alt="Laptop illustration" class="laptop-screen" />
          </div>
        </div>
        
        <h2 class="welcome-title">Welcome to Toolkit</h2>
        <p class="welcome-text">
          You're almost ready to explore! We're finalising your account verification.
        </p>
        
        <button type="button" class="btn btn-primary dashboard-btn" (click)="goToDashboard()">
          Go to Dashboard
        </button>
      </div>
    </div>
  </div>
</div>